import dayjs, { Dayjs } from 'dayjs'

function getStartEndIsoStrings(dates: [Date, Date]): [string, string]
function getStartEndIsoStrings(dates: [string, string]): [string, string]
function getStartEndIsoStrings(dates: [Dayjs, Dayjs]): [string, string]
function getStartEndIsoStrings(
  dates: [undefined | string, undefined | string],
): [undefined, undefined]

function getStartEndIsoStrings([startDate, endDate]: [
  Date | string | Dayjs | undefined,
  Date | string | Dayjs | undefined,
]): [string | undefined, string | undefined] {
  if (!startDate || !endDate) {
    return [undefined, undefined]
  }

  const start = dayjs(startDate).startOf('day').toISOString()
  const end = dayjs(endDate).endOf('day').toISOString()
  return [start, end]
}

export default getStartEndIsoStrings
